<div class="card">
   <div class="card-header">
     <h5>{{ 'Turn over' | translate }}</h5>
   </div>
   <div class="card-body">
     <div class="chart-container">
       <div class="row">
         <div class="col-12">
           <div id="chart-widget7">
            <apx-chart [chart]="turnOver.chart" [dataLabels]="turnOver.dataLabels" [stroke]="turnOver.stroke" [xaxis]="turnOver.xaxis" [grid]="turnOver.grid" [fill]="turnOver.fill" [colors]="turnOver.colors" [series]="turnOver.series" [tooltip]="turnOver.tooltip"></apx-chart>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>